/* eslint-disable no-undef */
import { pickBy } from 'lodash';
import { Set } from 'immutable';
import URI from 'urijs';

import { isSSR } from '../../helpers/ssr';
import { getUrlParams } from '../../utils/uriUtils';

export const uri = URI();

export const updateURL = () => {
  const clientUrl = URI.decode(uri.toString());
  if (!isSSR) window.history.replaceState(null, document.title, clientUrl);
};

// export const getUrlParams = () => {
//   const result = {};
//   const query = uri && uri.query();
//   if (query) {
//     query.split('&').forEach(param => {
//       const [key, value] = param.split('=');
//       result[key] = decodeURIComponent(value);
//     });
//   }
//   return result;
// };

export const getUrl = () => {
  const clientUrl = URI.decode(uri.toString());
  return clientUrl;
};

export const getFiltersFromUrl = () =>
  pickBy(getUrlParams(), (value, paramName) => paramName.startsWith('filter_'));

export const keyIn = (...keys) => {
  const keySet = Set(keys);
  return (v, k) => keySet.has(k);
};

// returns date for cheapest package
export const getCheapestDate = (dates) =>
  dates &&
  Object.keys(dates).reduce((cheapest, current) =>
    dates[cheapest] > dates[current] ? current : cheapest,
  );

/**
 * Returns extra params to show hotel page accouding to selected offer
 *
 * @typedef PackageInfo
 * @property {Array} dates
 * @property {number} price
 * @property {number} min_price_nights
 * @typedef Filters
 * @property {string} operators
 * @property {boolean} instantConfirm
 * @property {string} ltExtras
 * @property {boolean} freeCancel
 * @property {string} meals
 * @property {string} paymentBenefits
 * @param {PackageInfo} packageInfo
 * @param {Filters} filters
 * @returns
 */
export const getHotelExtraParams = (packageInfo, filters = {}) => {
  const { dates, price, min_price_nights } = packageInfo;
  const {
    operators,
    instantConfirm,
    ltExtras,
    freeCancel,
    meals,
    directFlight,
    paymentBenefits,
  } = filters || {};

  return {
    offer_price: price,
    offer_nights: min_price_nights,
    offer_date: getCheapestDate(dates),
    offer_operators: operators || '',
    offer_instant_confirm: instantConfirm || '',
    offer_direct_flight: directFlight || '',
    offer_free_cancel: freeCancel || '',
    offer_lt_extras: ltExtras || '',
    start_date: getCheapestDate(dates),
    offer_meals: meals || '',
    offer_labels: paymentBenefits ? [paymentBenefits].join() : '',
  };
};

export const getSuggestedTour = (adjacent_tour) => ({
  price: adjacent_tour.price,
  availability: null,
  nightsCount: adjacent_tour.duration,
  departureDate: adjacent_tour.start_date,
  instantConfirm: adjacent_tour.instant_confirm,
});
